import React from 'react'

import { AppRetailerBlock } from '@components'
import AppSearchesProgressCard from './ProgressCard'


export default function AppReportSearchesSitesModalBlock({ isLoading, sitesData }) {

	const { sitesInfo, completedPercentage, totalPercentage } = sitesData || {}

	return <AppSearchesProgressCard
		icon="globe"
		title="By website"
		isLoading={isLoading}
		current={completedPercentage}
		total={totalPercentage}
		rows={(sitesInfo || []).map(({ name, market, current, icon, total }, idx) => ({
			key: idx,
			current,
			total,
			label: <AppRetailerBlock icon={icon} retailer={name} country={market}/>,
		}))}
	/>
}
